import type { IconData } from '@stacksjs/iconify-core'

export const volumeUpCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-4.88-4.744a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005l1.824-1.71a2 2 0 0 1 1.367-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.367-.541l-1.824-1.71H5.121zm1.796-4.5H5.121v2.5h1.795l2.205 2.067V6.689zm6.081-.731a1 1 0 0 1 0-2a3.97 3.97 0 0 1 3.972 3.971v.04a3.97 3.97 0 0 1-3.972 3.972a1 1 0 1 1 0-2a1.97 1.97 0 0 0 1.972-1.972v-.04a1.97 1.97 0 0 0-1.972-1.971M13 9a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default volumeUpCircle
